import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { styles } from './Input.scss';

const cx = classNames.bind(styles);

const TextAreaComponent = ({
  isDisabled,
  hasError,

  placeholder,
  defaultValue,
  value,

  rows,
  size,

  onChange,
  forwardedRef,
  isInlineEditable,
  isResizable,
  isReadOnly,
  ...props
}) => {
  const classes = cx('c-input c-input-textarea', {
    [`c-input--${size}`]: size,
    'c-input--disabled': isDisabled,
    'c-input--error': hasError,
    'c-input--read-only': isReadOnly,
    'c-input-textarea--resizable': isResizable && !isDisabled && !isReadOnly,
  });

  const elem = (
    <textarea
      ref={forwardedRef}
      className={classes}
      disabled={isDisabled}
      placeholder={placeholder}
      defaultValue={defaultValue}
      value={value}
      rows={rows}
      onChange={onChange}
      readOnly={isReadOnly}
      {...props}
    />
  );

  if (isInlineEditable) {
    const wrapperClasses = cx('c-input-inline-editable-wrapper', {
      'c-input-inline-editable-wrapper--disabled': isDisabled,
      [`c-input-inline-editable-wrapper--${size}`]: size,
      'c-input-inline-editable-wrapper--error': hasError,
      'c-input-inline-editable-wrapper--read-only': isReadOnly,
    });

    return (
      <div className={wrapperClasses} title="Click to edit">
        {elem}
      </div>
    );
  }

  return elem;
};

export const TextArea = React.forwardRef((props, ref) => (
  <TextAreaComponent {...props} forwardedRef={ref} />
));

TextArea.propTypes = {
  isDisabled: PropTypes.bool,
  hasError: PropTypes.bool,

  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  value: PropTypes.string,

  /**
   * Initial number of rows
   */
  rows: PropTypes.number,

  size: PropTypes.oneOf(['small', 'medium', 'large']),

  onChange: PropTypes.func,

  /**
   * Inline editable mode
   */
  isInlineEditable: PropTypes.bool,
  /**
   * Allow to manually resize textarea
   */
  isResizable: PropTypes.bool,
  /**
   * Prevents the user from changing the value of the field
   */
  isReadOnly: PropTypes.bool,
};

TextArea.defaultProps = {
  isDisabled: false,
  hasError: false,
  rows: 2,
  size: 'medium',
  onChange: null,
  isResizable: true,
  isInlineEditable: false,
  isReadOnly: false,
};
